import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Inject,
  inject,
} from "@angular/core";
import { Category } from "../models/category";
import { LocationType } from "../models/location-type";
import { StandardService } from "../services/standard.service";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  FormArray,
} from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CreateNewNrbes } from "../models/createNewNrbes";
import { SuccessDialogComponent } from "../success-dialog/success-dialog.component";
import { Router } from "@angular/router";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { CryptographyService } from "../services/cryptography.service";
import { StandardTypeEnum, UserRoleEnum } from "../core/constant";
import { Country } from "../models/country";
import { STEPPER_GLOBAL_OPTIONS } from "@angular/cdk/stepper";
import { MatStepper } from "@angular/material/stepper";
import { StepperSelectionEvent } from "@angular/cdk/stepper";
import { Step } from "../stepper/stepper.component";
import { MultiSelectComponent } from "ng-multiselect-dropdown";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SnackbarComponent } from "../snackbar/snackbar.component";

interface ResourceLink {
  id: number;
  url: string;
  description: string;
}
@Component({
  selector: "app-add-nrbes",
  templateUrl: "./add-nrbes.component.html",
  styleUrls: ["./add-nrbes.component.scss"],
})
export class AddNrbesComponent implements OnInit {
  error: boolean = false;
  errorMessage: string = "";
  startTime: Date | null = null;
  endTime: Date | null = null;
  newCreatedStandard: any = [];
  loading: boolean = false;
  allStandardsAdded: boolean = false;
  userRole: number;
  addNrbesForm: FormGroup;
  selected = "option2";
  categories: Category[] = [];
  locationTypes: LocationType[] = [];
  countries: Country[] = [];
  createNewNrbes: CreateNewNrbes;

  formSteps: Step[] = [
    { id: 0, title: "Category & Location", status: "active" },
    { id: 1, title: "Description", status: "inactive" },
    { id: 2, title: "Details & Media", status: "inactive" },
    { id: 3, title: "Supporting Info", status: "inactive" },
    { id: 4, title: "Review & Submit", status: "inactive" },
  ];

  LocationsdropdownList = [];
  selectedLocations: any[] = [];
  dropdownSettings: IDropdownSettings;

  categoryDropdownList = [];
  selectedCategory = [];
  categorydropdownSettings: IDropdownSettings;

  countryDropdownList = [];
  countryselected = [];
  countrydropdownSettings: IDropdownSettings;

  currentStepIndex: number = 0;
  resourceId = 1;
  categoryForLastPage: string = "";

  step0Group: FormGroup;
  step1Group: FormGroup;
  step2Group: FormGroup;
  step3Group: FormGroup;
  step4Group: FormGroup;
  descriptionChecked: Boolean = false;

  detailsExpanded: boolean = false;
  additionalInfoExpanded: boolean = false;
  createdOn: Date;

  // resourceLinks: ResourceLink[] = [
  //     { id: this.resourceId++, url: "", description: "" },
  //   ];

  //   addLink(): void {
  //     this.resourceLinks.push({
  //       id: this.resourceId++,
  //       url: "",
  //       description: "",
  //     });
  //   }
  //   removeLink(link: ResourceLink): void {
  //     if (this.resourceLinks.length === 1) {
  //       link.url = "";
  //       link.description = "";
  //     } else {
  //       if (link.url || link.description) {
  //         link.url = "";
  //         link.description = "";
  //       } else {
  //         this.resourceLinks = this.resourceLinks.filter(
  //           (item) => item.id !== link.id
  //         );
  //       }
  //     }
  //   }
  pasteLink(link) {
    void 0;
    if (navigator.clipboard) {
      navigator.clipboard
        .readText()
        .then((text) => {
          if (text.includes("www.share.mcd.com")) {
            link.get("url").setValue(text);
            void 0;
            const url = link.get("url")?.value;
            const title = link.get("title")?.value;
            if (title && url) {
              this.addNrbesForm.get("linksFieldValid")?.clearValidators();
              this.addNrbesForm
                .get("linksFieldValid")
                ?.updateValueAndValidity();
            } else {
              this.addNrbesForm
                .get("linksFieldValid")
                ?.setValidators(Validators.required);
              this.addNrbesForm
                .get("linksFieldValid")
                ?.updateValueAndValidity();
            }
          } else {
            alert("not a valid URL");
          }
        })
        .catch((err) => {
          console.error("Failed to read clipboard: ", err);
        });
    } else {
      alert("Clipboard API not supported in this browser.");
    }
  }

  onEnterResourceTitle(link) {
    const url = link.get("url")?.value.trim();
    const title = link.get("title")?.value.trim();

    const ctrl = this.addNrbesForm.get("linksFieldValid");
    if ((url && title) || (!url && !title)) {
      ctrl?.clearValidators();
    } else {
      ctrl?.setValidators(Validators.required);
    }

    ctrl?.updateValueAndValidity();
  }

  openLink(url: string) {
    if (url && url.trim() !== "") {
      const validUrl =
        url.startsWith("http://") || url.startsWith("https://")
          ? url
          : "https://" + url;

      window.open(validUrl, "_blank");
    } else {
      alert("No valid link provided!");
    }
  }
  private _snackBar = inject(MatSnackBar);

  @Output() nrbesEditPopupEmit: EventEmitter<any> = new EventEmitter();
  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private standardService: StandardService,
    private ngbModal: NgbModal,
    private router: Router,
    private cryptographyService: CryptographyService,
    @Inject(LOCAL_STORAGE)
    private storage: WebStorageService,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: false,
      idField: "id",
      textField: "name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 6,
      allowSearchFilter: true,
    };
    this.categorydropdownSettings = {
      closeDropDownOnSelection: true,
      singleSelection: true,
      idField: "id",
      textField: "name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.countrydropdownSettings = {
      closeDropDownOnSelection: true,
      singleSelection: true,
      idField: "id",
      textField: "name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.createdOn = new Date();
    this.createForm();
    this.addLinks();
    this.addNrbesForm.controls.newRestaurantEffectiveFrom.setValue(new Date());
    this.addNrbesForm.controls.effectiveFrom.setValue(new Date());
  }

  createResourceLink(): FormGroup {
    return this.fb.group({
      url: [""],
      title: [""],
    });
  }
  addLinks() {
    this.resourceLinks1.push(this.createResourceLink());
  }
  removeLink(index: number): void {
    const linkGroup = this.resourceLinks1.at(index);

    if (linkGroup) {
      const url = linkGroup.get("url")?.value;
      const desc = linkGroup.get("title")?.value;
      if (url || desc) {
        linkGroup.get("url")?.setValue("");
        linkGroup.get("title")?.setValue("");
      } else {
        if (this.resourceLinks1.length > 1) {
          this.resourceLinks1.removeAt(index);
        }
      }
    }
    const hasInvalidRow = this.resourceLinks1.controls.some((link) => {
      const url = link.get("url")?.value;
      const title = link.get("title")?.value;
      return (url && !title) || (!url && title);
    });

    const ctrl = this.addNrbesForm.get("linksFieldValid");

    if (hasInvalidRow) {
      ctrl?.setValidators(Validators.required);
    } else {
      ctrl?.clearValidators();
    }

    ctrl?.updateValueAndValidity();
  }

  get resourceLinks1() {
    return this.addNrbesForm.get("resourceLinks1") as FormArray;
  }
  get hasResourceUrls(): boolean {
    return this.resourceLinks1.controls.some(
      (c) => !!c.get("url")?.value?.trim(),
    );
  }

  get selectedLocationNames(): string {
    return this.selectedLocations?.map((loc) => loc.name).join(", ") || "";
  }
  createForm(): void {
    //debugger;
    this.userRole = this.cryptographyService.decryptData(
      this.storage.get("userRole"),
    );
    let locationTypesArray = [];
    let categoriesArray = [];
    if (this.userRole == UserRoleEnum.AOWAdmin) {
      this.addNrbesForm = this.fb.group({
        title: ["", Validators.required],
        note: [""],
        category: categoriesArray,
        locationTypes: locationTypesArray,
        categoryId: ["", Validators.required],
        locationTypeId: ["", Validators.required],
        standardDescription: ["", Validators.required],
        newrestaurantdescription: ["", Validators.required],
        additionalInformation: [""],
        effectiveFrom: ["", Validators.required],
        newRestaurantEffectiveFrom: ["", Validators.required],
        keyContact: ["", [Validators.email]],
        keyContactDesc: [""],
        countryId: ["", Validators.required],
        linksFieldValid: [""],
        resourceLinks1: this.fb.array([]),
      });
    } else {
      this.addNrbesForm = this.fb.group({
        title: ["", Validators.required],
        note: ["", Validators.required],
        category: categoriesArray,
        locationTypes: locationTypesArray,
        categoryId: ["", Validators.required],
        locationTypeId: ["", Validators.required],
        standardDescription: ["", Validators.required],
        newrestaurantdescription: ["", Validators.required],
        additionalInformation: [""],
        countryId: [""],
        effectiveFrom: ["", Validators.required],
        newRestaurantEffectiveFrom: ["", Validators.required],
        keyContact: ["", [Validators.email]],
        keyContactDesc: [""],
        resourceLinks1: this.fb.array([]),
        linksFieldValid: [""],
      });

      this.step0Group = this.fb.group(
        {
          title: this.addNrbesForm.get("title"),
          categoryId: this.addNrbesForm.get("categoryId"),
          locationTypeId: this.addNrbesForm.get("locationTypeId"),
          subLocationTypeId: this.addNrbesForm.get("subLocationTypeId"),
        },
        { validators: this.checkFormFieldValidations },
      );
      this.step1Group = this.fb.group(
        {
          standardDescription: this.addNrbesForm.get("standardDescription"),
          newrestaurantdescription: this.addNrbesForm.get(
            "newrestaurantdescription",
          ),
        },
        { validators: this.checkFormFieldValidations },
      );

      this.step2Group = this.fb.group(
        {
          note: this.addNrbesForm.get("note"),
          linksFieldValid: this.addNrbesForm.get("linksFieldValid"),

          // resourceLinks: this.addNrbesForm.get("resourceLinks1"),
        },

        { validators: this.checkFormFieldValidations },
      );
    }

    this.step3Group = this.fb.group(
      {
        keyContact: this.addNrbesForm.get("keyContact"),
        // resourceLinks: this.addNrbesForm.get("resourceLinks1"),
      },

      { validators: this.checkFormFieldValidations },
    );

    this.loading = true;
    this.standardService
      .GetMasterDataForAddNrbes(
        this.cryptographyService.decryptData(this.storage.get("userRole")),
        this.cryptographyService.decryptData(this.storage.get("userId")),
      )
      .subscribe((data: any) => {
        this.countries = data.countries;
        this.countryDropdownList = data.countries;
        this.categories = data.categories;
        this.categoryDropdownList = data.categories;
        this.locationTypes = data.locationTypes;
        this.LocationsdropdownList = data.locationTypes;

        if (this.locationTypes != null) {
          this.locationTypes
            .sort((firstItem, nextItem) =>
              firstItem.name.localeCompare(nextItem.name),
            )
            .forEach((element) => {
              locationTypesArray.push(
                this.fb.group({
                  id: new FormControl(element.id),
                  name: new FormControl(element.name),
                }),
              );
            });
        }

        if (this.categories != null) {
          this.categories
            .sort((firstItem, nextItem) =>
              firstItem.name.localeCompare(nextItem.name),
            )
            .forEach((element) => {
              categoriesArray.push(
                this.fb.group({
                  id: new FormControl(element.id),
                  name: new FormControl(element.name),
                }),
              );
            });
        }
        this.loading = false;
      });
  }

  reset() {
    this.addNrbesForm.controls.title.reset();
    this.addNrbesForm.controls.note.reset();
    this.addNrbesForm.controls.additionalInformation.reset();
    this.addNrbesForm.controls.standardDescription.reset();
    this.addNrbesForm.controls.newrestaurantdescription.reset();
    this.addNrbesForm.controls.locationTypeId.reset();
    this.addNrbesForm.controls.effectiveFrom.reset();
    this.addNrbesForm.controls.newRestaurantEffectiveFrom.reset();
    this.addNrbesForm.controls.categoryId.setValue(null);
    this.addNrbesForm.controls.locationTypeId.setValue(null);
  }

  setSelectedLocationType(locationType) {
    this.addNrbesForm.controls.locationTypeId.setValue(locationType.value);
  }

  setSelectedCategory(category) {
    this.addNrbesForm.controls.categoryId.setValue(parseInt(category.value));
  }

  onBuildDateString(date: string) {
    let partsArray = date.split("/");
    let buildedDate = "";
    partsArray.forEach((x) => {
      if (x.length == 1 || x.length == 2) {
        if (x.length == 1) {
          buildedDate += ("0" + x).slice(-2) + "/";
        } else {
          buildedDate += x + "/";
        }
      } else {
        buildedDate += x;
      }
    });
    return buildedDate;
  }

  close() {
    this.reset();
    this.nrbesEditPopupEmit.emit();

    this.activeModal.dismiss();
  }

  startTimer() {
    this.startTime = new Date();
    // alert("timer started");
  }
  endTimer() {
    if (!this.startTime) {
      console.error("Start time is not set.");
      return;
    }
    this.endTime = new Date();
    const timeDiff = this.endTime.getTime() - this.startTime.getTime();
    const seconds = timeDiff / 1000;
    // alert("timer stopped");

    return seconds;
  }

  submit() {
    this.startTimer();
    this.loading = true;
    this.newCreatedStandard = [];

    var nrbes = new CreateNewNrbes();
    nrbes.title = this.addNrbesForm.controls.title.value;
    nrbes.note = this.addNrbesForm.controls.note.value;
    nrbes.locationTypeId = this.addNrbesForm.controls.locationTypeId.value;
    nrbes.categoryId = parseInt(this.addNrbesForm.controls.categoryId.value);
    nrbes.description = this.addNrbesForm.controls.standardDescription.value;
    nrbes.additionalInformation =
      this.addNrbesForm.controls.additionalInformation.value;
    nrbes.newrestaurantDescription =
      this.addNrbesForm.controls.newrestaurantdescription.value;
    nrbes.effectiveFrom =
      this.addNrbesForm.controls.effectiveFrom.value != null
        ? this.onBuildDateString(
            new Date(this.addNrbesForm.controls.effectiveFrom.value)
              .toLocaleDateString("en-US")
              .replace(/\u200E/g, ""),
          )
        : null;
    const links = this.addNrbesForm.controls.resourceLinks1.value;

    nrbes.links = links.filter(
      (link) => link.url?.trim() || link.title?.trim(),
    );
    // nrbes.links = this.addNrbesForm.controls.resourceLinks1.value;
    nrbes.keyContact = {
      email: this.addNrbesForm.controls.keyContact.value,
      emailDescription: this.addNrbesForm.controls.keyContactDesc.value,
    };
    nrbes.newRestaurantEffectiveFrom =
      this.addNrbesForm.controls.newRestaurantEffectiveFrom.value != null
        ? this.onBuildDateString(
            new Date(
              this.addNrbesForm.controls.newRestaurantEffectiveFrom.value,
            )
              .toLocaleDateString("en-US")
              .replace(/\u200E/g, ""),
          )
        : null;

    nrbes.standardStatusId = 6;
    nrbes.standardTypeId = StandardTypeEnum.LocalStandard;
    nrbes.createdUserId = this.cryptographyService.decryptData(
      this.storage.get("userId"),
    );
    nrbes.countryId = this.cryptographyService.decryptData(
      this.storage.get("countryId"),
    );

    if (this.addNrbesForm.controls.countryId.value == "") {
      nrbes.countryId = this.cryptographyService.decryptData(
        this.storage.get("countryId"),
      );
      this.standardService.createNewNrbes(nrbes).subscribe(
        (data: any) => {
          void 0;

          const modalRef = this.ngbModal.open(SuccessDialogComponent);
          if (data) {
            modalRef.componentInstance.message =
              "You have successfully added the standard.";
            this.newCreatedStandard.push({
              name: nrbes.title,
              totalTime: this.endTimer(),
              eventType: "NewStandardsPROD",
              status: "Created",
              standardType: "MarketStandard",
              session: JSON.parse(localStorage.getItem("NRBA_SESSION")).value,
              error: this.error,
              errorMessage: "No error",
            });
            void 0;
            this.standardService
              .recordSearchEvent(this.newCreatedStandard)
              .subscribe({ next: () => void 0, error: () => void 0 });
          }
          this.loading = false;
          modalRef.componentInstance.nrbesSuccessPopupEmit.subscribe(
            (receivedEntry) => {
              this.ngbModal.dismissAll();
              this.router.navigate(["/nrbeslist"]);
            },
          );
          this.reset();
        },
        (error) => {
          this.loading = false;

          void 0;

          const modalRef = this.ngbModal.open(SuccessDialogComponent);
          modalRef.componentInstance.title = "Error";
          modalRef.componentInstance.message =
            "Some error occurred. Please try again after some time";
          modalRef.componentInstance.nrbesSuccessPopupEmit.subscribe(() => {
            this.ngbModal.dismissAll();
          });
          this.newCreatedStandard.push({
            name: nrbes.title,
            totalTime: this.endTimer(),
            eventType: "NewStandardsPROD",
            status: "Failed",
            standardType: "MarketStandard",
            session: JSON.parse(localStorage.getItem("NRBA_SESSION")).value,
            error: true,
            errorMessage: error.message,
          });
          void 0;
          this.standardService
            .recordSearchEvent(this.newCreatedStandard)
            .subscribe({ next: () => void 0, error: () => void 0 });
        },
      );
    }

 
    else {
      nrbes.countryId = [this.addNrbesForm.controls.countryId.value];
      this.standardService.createNewNrbes(nrbes).subscribe((data: any) => {
        const modalRef = this.ngbModal.open(SuccessDialogComponent);
        this.newCreatedStandard.push({
          name: nrbes.title,
          totalTime: this.endTimer(),
          eventType: "NewStandardsPROD",
          status: "Created",
          standardType: "MarketStandard",
          session: JSON.parse(localStorage.getItem("NRBA_SESSION")).value,
          error: true,
          errorMessage: "Error is there",
        });
        void 0;
        this.standardService
          .recordSearchEvent(this.newCreatedStandard)
          .subscribe({ next: () => void 0, error: () => void 0 });
        modalRef.componentInstance.message =
          "You have successfully added the .";
        this.loading = false;
        modalRef.componentInstance.nrbesSuccessPopupEmit.subscribe(
          (receivedEntry) => {
            this.ngbModal.dismissAll();
            this.router.navigate(["/nrbeslist"]);
          },
        );
        this.reset();
      });
    }
  }
  onPasteCleanup(fieldNmae: string) {
    setTimeout(() => {
      const ctrl = this.addNrbesForm.get(fieldNmae);
      if (!ctrl) return;

      const cleaned = (ctrl.value || "")
        .replace(/[\u00A0\u2000-\u200B]/g, " ")
        .replace(/\s{2,}/g, "  ");

      if (ctrl.value !== cleaned) {
        ctrl.setValue(cleaned, { emitEvent: false });
      }
    }, 0);
  }

  cleanQuillHTML(html: string): string {
    return (
      html
        .replace(/\u00A0|\u202F/g, " ")
        .replace(/\uFEFF/g, "")
        // .replace(/\u200B/g, '')         // Remove zero-width space
        // .replace(/\s+/g, ' ')           // Collapse multiple spaces if needed
        // .replace(/<span[^>]*>(\s*)<\/span>/g, '$1') // Remove empty spans
        .trim()
    );
  }

  onEditorCreated(quill: any, quillType: string) {
    const value = this.addNrbesForm.get(quillType)?.value;
    if (value) {
      quill.clipboard.dangerouslyPasteHTML(value);
    }
    quill.root.addEventListener("paste", (event: ClipboardEvent) => {
      const pastedText = event.clipboardData?.getData("text/plain");
      const pastedHtml = event.clipboardData?.getData("text/html");

      // void 0;
      // void 0;
      if (pastedHtml) {
        event.preventDefault();

        const cleanHtml = this.cleanQuillHTML(pastedHtml);
        const delta = quill.clipboard.convert(cleanHtml);

        quill.updateContents(delta, "user");
      }
    });
  }

  onStepChange(event: StepperSelectionEvent): void {
    // this.currentStepIndex = event.selectedIndex;
  }

  onCategorySelect(item: any) {
    void 0;
    // this.setCategory(item.id);
    this.addNrbesForm.controls.categoryId.setValue(item.id);
    const selected = this.addNrbesForm.value.categoryId;
    this.categoryForLastPage = item.name;
    void 0;
    void 0;
  }
  onSelectAll(items: any) {
    void 0;
    // void 0;
    const AllSelectedids = items.map((x) => {
      return x.id;
    });
    // this.setSublocationsAndSublocationsvalidations(AllSelectedids);
    this.addNrbesForm.controls.locationTypeId.setValue(AllSelectedids);
  }

  onCountrySelect(item: any) {
    this.addNrbesForm.controls.countryId.setValue(item.id);
  }

  copyDescriptionToExisting(isChecked: boolean): void {
    const newDesc =
      this.addNrbesForm.get("newrestaurantdescription")?.value || "";
    const descControl = this.addNrbesForm.get("standardDescription");

    if (isChecked && this.addNrbesForm.get("newrestaurantdescription").valid) {
      this.descriptionChecked = isChecked;
      descControl?.setValue(newDesc);
      descControl?.disable();
    } else {
      this.descriptionChecked = false;
      descControl?.enable();
      descControl?.reset();
    }
  }

  nextStep(): void {
    if (this.currentStepIndex == 0) {
      if (this.step0Group.get("title")?.invalid) {
        this.step0Group.get("title")?.markAsTouched();
      }

      if (this.step0Group.get("categoryId")?.invalid) {
        this.step0Group.get("categoryId")?.markAsTouched();
      }

      if (this.step0Group.get("locationTypeId")?.invalid) {
        this.step0Group.get("locationTypeId")?.markAsTouched();
      }
      if (this.step0Group.invalid) {
        return;
      }
    }
    if (this.currentStepIndex == 1) {
      if (this.step1Group.get("standardDescription")?.invalid) {
        this.step1Group.get("standardDescription")?.markAsTouched();
      }

      if (this.step1Group.get("newrestaurantdescription")?.invalid) {
        this.step1Group.get("newrestaurantdescription")?.markAsTouched();
      }

      if (this.step1Group.invalid) {
        return;
      }
    }
    if (this.currentStepIndex == 2) {
      if (this.step2Group.get("note")?.invalid) {
        this.step2Group.get("note")?.markAsTouched();
      }
      if (this.step2Group.get("linksFieldValid")?.invalid) {
        this.step2Group.get("linksFieldValid")?.markAsTouched();
      }

      if (this.step2Group.invalid) {
        return;
      }
    }
    if (this.currentStepIndex == 3) {
      if (this.step3Group.get("keyContact")?.invalid) {
        this.step3Group.get("keyContact")?.markAsTouched();
      }

      if (this.step3Group.invalid) {
        return;
      }
    }

    if (this.currentStepIndex <= this.formSteps.length - 1) {
      this.formSteps[this.currentStepIndex].status = "completed";
      this.currentStepIndex++;
      this.formSteps[this.currentStepIndex].status = "active";
    }
  }

  previousStep(): void {
    if (this.currentStepIndex > 0) {
      this.formSteps[this.currentStepIndex].status = "inactive";
      this.currentStepIndex--;
      this.formSteps[this.currentStepIndex].status = "active";
    }
  }
  clearAllSelected() {
    this.selectedLocations = [];
    this.addNrbesForm.controls.locationTypeId.setValue([]);
    // this.locationDropdown.clearAll();   // 🔥 clears UI checkboxes
  }

  onItemSelect(item: any) {
    void 0;
    void 0;
    const selected = this.addNrbesForm.value.locationTypeId;
    void 0;
    // void 0;
    const Selectedids = this.selectedLocations.map((x) => {
      return x.id;
    });
    void 0;
    // this.setLocationCategoryMapping(Selectedids)
    // this.setSublocationsAndSublocationsvalidations(Selectedids);
    this.addNrbesForm.controls.locationTypeId.setValue(Selectedids);

    const selected2 = this.addNrbesForm.value.locationTypeId;
    void 0;
  }

  checkFormFieldValidations(group: FormGroup) {
    if (this.currentStepIndex == 0) {
      const { title, categoryId, locationTypeId } = group.controls;
      return title.valid && categoryId.valid && locationTypeId.valid
        ? null
        : { stepInvalid: true };
    }

    if (this.currentStepIndex == 1) {
      const { standardDescription, newrestaurantdescription } = group.controls;
      return standardDescription.valid && newrestaurantdescription.valid
        ? null
        : { stepInvalid: true };
    }
    if (this.currentStepIndex == 2) {
      const { note, resourceLinks, linksFieldValid } = group.controls;
    
      return note.valid && linksFieldValid.valid ? null : { stepInvalid: true };
    }

    if (this.currentStepIndex == 3) {
      const { keyContact } = group.controls;

      return keyContact.valid ? null : { stepInvalid: true };
    }
  }
  onPasteLink(event: ClipboardEvent, link) {
    event.preventDefault();
    const pastedText = event.clipboardData?.getData("text") || "";

    if (!pastedText.includes("www.share.mcd.com")) {
      alert("Not a valid URL");
    } else {
      link.get("url")?.setValue(pastedText);
      const url = link.get("url")?.value;
      const title = link.get("title")?.value;
      if (title && url) {
        this.addNrbesForm.get("linksFieldValid")?.clearValidators();
        this.addNrbesForm.get("linksFieldValid")?.updateValueAndValidity();
      } else {
        this.addNrbesForm
          .get("linksFieldValid")
          ?.setValidators(Validators.required);
        this.addNrbesForm.get("linksFieldValid")?.updateValueAndValidity();
      }
    }
  }

  toggleDetails() {
    this.detailsExpanded = !this.detailsExpanded;
  }
  toggleDetails2() {
    this.additionalInfoExpanded = !this.additionalInfoExpanded;
  }

  copyText(content: any) {
    navigator.clipboard.writeText(content);
    this.openSnackBar();
  }

  getDetails() {
    return this.sanitizer.bypassSecurityTrustHtml(
      this.addNrbesForm.get("note")?.value,
    );
  }
  getAdditionalInfo() {
    return this.sanitizer.bypassSecurityTrustHtml(
      this.addNrbesForm.get("additionalInformation")?.value,
    );
  }
  openSnackBar() {
    this._snackBar.openFromComponent(SnackbarComponent, {
      duration: 2000,
      data: {
        message: "Object Copied to clipboard!",
      },
    });
  }
  disableTyping(event: KeyboardEvent) {
    if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "v") {
      return;
    }

    const allowedKeys = [
      "Tab",
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "ArrowDown",
    ];

    if (!allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }
  checkFormValidity() {
    if (
      this.step0Group.invalid ||
      this.step1Group.invalid ||
      this.step2Group.invalid ||
      this.step3Group.invalid
    ) {
      return true;
    } else {
      return false;
    }
  }
}
